import styled from 'styled-components/macro';
import { BREAKPOINTS } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const StartButtonWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};

  @media ${BREAKPOINTS.sm} {
    ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  }
`;

export const ModalWrapper = styled.div``;

export const StartYourTripsButton = styled.button`
  width: 230px;
  height: 62px;
  background: ${COLORS.mainColor};
  border-radius: 20px;
  ${FONT_FAMILY.FontLight}
  color:${COLORS.white};
  ${FONTS.font16};

  &:hover {
    background: ${COLORS.mainColor_op7};
  }

  @media ${BREAKPOINTS.lg} {
    width: 190px;
    height: 50px;
  }

  @media ${BREAKPOINTS.md} {
    width: 120px;
    height: 40px;
    ${FONTS.font12};
  }
`;

export const StartYourTripsLine = styled.img`
  width: 180px;
  height: 100px;
  margin-right: 70px;
  margin-top: 30px;

  @media ${BREAKPOINTS.lg} {
    width: 154px;
    height: 84px;
  }

  @media ${BREAKPOINTS.sm} {
    width: 108px;
    height: 68px;
    margin-right: unset;
    margin-left: 20px;
  } ;
`;
